import { atom } from "recoil";

const clientsAtom = atom({
  key: 'clients',
  default: {
    payload: [],
    loading: false,
    total: 0
  }
});

const crudClientAtom = atom({
  key: 'crudClient',
  default: {
    status: 500,
    message: '',
    loading: false
  }
});

export { crudClientAtom, clientsAtom };